import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  return (
    <div className="navbar-container">
      <Link to="/" className="nav-button">
        🏠 Home
      </Link>
      <Link to="/scoreboard" className="nav-button">
        🔢 Scoreboard
      </Link>
    </div>
  );
};

export default Navbar;
